import {
  ActionReducerMapBuilder,
  Draft,
  PayloadAction,
  Slice,
  SliceCaseReducers,
  createAsyncThunk,
  createSlice
} from '@reduxjs/toolkit';
import { NoInfer } from '@reduxjs/toolkit/src/tsHelpers';

import { ModelError, State } from 'models';
import { FeatureInfoInventeringarResponse } from 'models/apiModels/FeatureInfoInventeringarResponse';

import { Coordinate } from 'ol/coordinate';

import {
  FulfilledActionType,
  PendingActionType,
  RejectedActionType,
  errorOr,
  fulfilled,
  pending,
  rejected
} from './storeHelpers';

export const getFeatureInfoInventeringar = createAsyncThunk<
  any,
  { url: string; coordinate: Coordinate },
  { rejectValue: ModelError }
>('FeatureInfoInventeringar/fetch', async ({ url, coordinate }, { rejectWithValue, dispatch }): Promise<any> => {
  const res = await fetch(url);
  const response = await errorOr<FeatureInfoInventeringarState>(res, rejectWithValue);
  dispatch(setGetFeatureInfoInventeringarRequestedAt(coordinate));
  return response;
});

interface FeatureInfoInventeringarState extends State<FeatureInfoInventeringarResponse> {
  requestedAt: Coordinate | undefined;
}

const initialState: FeatureInfoInventeringarState = {
  requestStatus: 'idle',
  data: undefined,
  requestType: undefined,
  currentRequestId: undefined,
  error: undefined,
  requestedAt: undefined
};

const featureInfoInventeringarSlice: Slice<
  FeatureInfoInventeringarState,
  SliceCaseReducers<FeatureInfoInventeringarState>,
  'featureInfoInventeringar'
> = createSlice({
  name: 'featureInfoInventeringar',
  initialState,
  reducers: {
    clearFeatureInfoInventeringar: (state: Draft<FeatureInfoInventeringarState>): void => {
      state.data = undefined;
      state.requestedAt = undefined;
    },
    setGetFeatureInfoInventeringarRequestedAt: (
      state: Draft<FeatureInfoInventeringarState>,
      action: PayloadAction<Coordinate>
    ): void => {
      state.requestedAt = action.payload;
    }
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<FeatureInfoInventeringarState>>): void => {
    builder.addCase(
      getFeatureInfoInventeringar.pending,
      (state: Draft<FeatureInfoInventeringarState>, action: PendingActionType): void => pending(state, action)
    );
    builder.addCase(
      getFeatureInfoInventeringar.fulfilled,
      (state: Draft<FeatureInfoInventeringarState>, action: FulfilledActionType<FeatureInfoInventeringarResponse>) => {
        fulfilled(state, action);
      }
    );
    builder.addCase(
      getFeatureInfoInventeringar.rejected,
      (state: Draft<FeatureInfoInventeringarState>, action: RejectedActionType): void => rejected(state, action)
    );
  }
});

export const { clearFeatureInfoInventeringar, setGetFeatureInfoInventeringarRequestedAt } =
  featureInfoInventeringarSlice.actions;
export default featureInfoInventeringarSlice.reducer;
